import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
var subHeaderComponent = /** @class */ (function () {
    function subHeaderComponent(localSt, router, location) {
        this.localSt = localSt;
        this.router = router;
        this.location = location;
        this.backButton = { title: '', link: '' };
        this.showSubHeaderInPages = ['/about', '/how-to-order', '/faq'];
    }
    subHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.localSt.retrieve('subHeaderHeading') ? this.heading = this.localSt.retrieve('subHeaderHeading') : this.heading = '';
        if (this.localSt.retrieve('backButton')) {
            this.backButton = {
                title: this.localSt.retrieve('backButton').title,
                link: this.localSt.retrieve('backButton').link
            };
            this.showButton = this.localSt.retrieve('backButton').show;
        }
        this.localSt.observe('subHeaderHeading').subscribe(function (data) {
            data ? _this.heading = data : _this.heading = '';
        });
        this.localSt.observe('backButton').subscribe(function (data) {
            if (data) {
                _this.backButton = {
                    title: data.title,
                    link: data.link
                };
                _this.showButton = data.show;
            }
        });
    };
    subHeaderComponent.prototype.backClick = function () {
        this.router.navigate([this.backButton.link]);
        this.localSt.store('hideSearchBar', '1');
    };
    subHeaderComponent.prototype.isHidden = function () {
        var path = this.location.path();
        return !(this.showSubHeaderInPages.indexOf(path) > -1);
    };
    return subHeaderComponent;
}());
export { subHeaderComponent };



// WEBPACK FOOTER //
// ./src/app/template/subheader/subheader.component.ts.pre-build-optimizer.js